












































































































import Vue from 'vue';
import SaveData from '@/classes/saveData/saveData';
import SiteSetting from '@/classes/siteSetting';
import SaveItem from './SaveItem.vue';

export default Vue.extend({
  components: { SaveItem },
  name: 'SaveDataView',
  props: {
    rootData: {
      type: SaveData,
      required: true,
    },
    handleInform: {
      type: Function,
      required: true,
    },
    enabledFixDrawer: {
      type: Boolean,
      default: false,
    },
    fixedDrawer: {
      type: Boolean,
      default: false,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  methods: {
    addNewFile() {
      // 新規データ
      const data = new SaveData();
      data.name = 'New Data ';
      data.isUnsaved = false;
      this.addNewSaveData(data);
    },
    addNewDirectory() {
      // 新規フォルダー
      const folder = new SaveData();
      folder.name = 'New Folder ';
      folder.isDirectory = true;
      folder.isUnsaved = false;
      this.addNewSaveData(folder);
      this.handleInform('New Folder created.');
    },
    addNewSaveData(saveData: SaveData) {
      const data = this.rootData.childItems;
      for (let i = 0; i < data.length; i += 1) {
        if (data[i].addNewFileToSelectedData(saveData)) {
          // セーブデータの更新を通知
          this.$store.dispatch('updateSaveData', this.rootData);
          this.handleInform(`新しい${saveData.isDirectory ? 'フォルダー' : '編成'}を作成しました。`);
          return;
        }
      }

      // 最後まで選択状態ファイルが見つからなければ、保存されたデータの直下いき
      const folder = this.rootData.childItems.find((v) => v.isDirectory);
      if (folder) {
        if (!saveData.isDirectory) {
          saveData.name = folder.getNewSaveDataName();
        }
        folder.isOpen = true;
        folder.childItems.push(saveData);
        folder.sortChild();
        // セーブデータの更新を通知
        this.$store.dispatch('updateSaveData', this.rootData);
        this.handleInform(`新しい${saveData.isDirectory ? 'フォルダー' : '編成'}を作成しました。`);
      }
    },
    openAllDirectory() {
      this.rootData.openDirectory();
    },
    closeAllDirectory() {
      this.rootData.closeDirectory();
    },
    deleteChild(index: number) {
      this.rootData.childItems = this.rootData.childItems.filter((v, i) => i !== index);
      this.handleInform('削除が完了しました。');
      // セーブデータの更新を通知
      this.$store.dispatch('updateSaveData', this.rootData);
    },
    openGitHub() {
      window.open('https://github.com/arill/kc-web/', '_blank');
    },
    toggleFixDrawer() {
      const setting = this.$store.state.siteSetting as SiteSetting;
      setting.fixedDrawer = !setting.fixedDrawer;
      this.$store.dispatch('updateSetting', setting);
    },
  },
});
